import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { RequestCreationFormService } from "@fiduciaria/RequestCreation/Services/request-creation-form.service";
import { TrustService } from "@fiduciaria/Shared/Services/trust.service";
import { Dependency } from "@fiduciaria/Shared/Types/dependency.interface";
import { EscrowTypeCode } from "@fiduciaria/Shared/Types/Enums/escrow-type.enum";
import { Escrow } from "@fiduciaria/Shared/Types/escrow.interface";
import { TrustSubType, TrustType } from "@fiduciaria/Shared/Types/type.interface";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { Unsubscriber } from "@shared/Components/Unsubscriber/unsubscriber.component";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

@Component({
  selector: "app-customer-form",
  templateUrl: "./customer-form.component.html",
})
export class CustomerFormComponent extends Unsubscriber implements OnInit {
  public escrows$: Observable<Escrow[]>;
  public areas$: Observable<Dependency[]>;
  public types$: Observable<TrustType[]>;
  public subTypes$: Observable<TrustSubType[]>;

  public form: FormGroup;

  public isUserFidiciary: boolean;
  public isUserCanalesFidiciary: boolean;

  private readonly rolesPermitidos = ["Canales Fiduciaria", "Administrador Corporativo Fiduciaria", "Operativo Fiduciaria"];

  public get isRealEstateEscrow(): boolean {
    return this.escrow?.idTipoFideicomiso?.sCodigo === EscrowTypeCode.RealEstate;
  }

  constructor(
    private readonly trustService: TrustService,
    private readonly formBuilder: FormBuilder,
    private readonly requestCreationForm: RequestCreationFormService,
    private readonly userRepository: UsuariosRepository
  ) {
    super();
  }

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      escrow: [null, Validators.required],
      area: [null, Validators.required],
      type: [null, Validators.required],
      subtype: [null, Validators.required],
    });

    this.userRepository.getInfoClienteActual().subscribe((usuario) => {
      this.isUserFidiciary = usuario.usuarioRole.some((x) => this.rolesPermitidos.includes(x.role.nombre));
      this.isUserCanalesFidiciary = usuario.usuarioRole.some((x) => this.rolesPermitidos[0] === x.role.nombre);

      if (this.isUserCanalesFidiciary) {
        this.escrows$ = this.trustService.getEscrowsAll();
        this.areas$ = this.trustService.getDependencies();
      } else if (this.isUserFidiciary) {
        this.escrows$ = this.trustService.getUserFideicomisos();
      } else {
        this.areas$ = this.trustService.getDependencies();
        this.escrows$ = this.trustService.getEscrows();
      }
    });

    this.anotherSubscription = this.form.get("escrow").valueChanges.subscribe((escrow: Escrow) => {
      if (this.isUserFidiciary && !this.isUserCanalesFidiciary) {
        this.form.get("area").reset();
        this.areas$ = this.trustService.getAreasByIdFideicomiso(escrow.id);
      }

      this.form.get("type").reset();
      this.form.get("subtype").reset();
    });

    this.anotherSubscription = this.form.get("area").valueChanges.subscribe((area: Dependency) => {
      this.form.get("type").reset();
      this.types$ = area ? this.trustService.getTypes(area.key).pipe(shareReplay(1)) : null;
    });

    this.anotherSubscription = this.form.get("type").valueChanges.subscribe((type) => {
      this.form.get("subtype").reset();
      this.subTypes$ = type ? this.trustService.getSubTypes(type.key).pipe(shareReplay(1)) : null;
    });

    this.anotherSubscription = this.requestCreationForm.reset.subscribe(() => {
      this.form.reset();
    });
  }

  public onSubmit(): void {
    const { value } = this.form;

    this.requestCreationForm.addValue(value);
  }

  public get escrow(): Escrow {
    return this.form.get("escrow").value;
  }
}
